export default class CensusDataByZipCode {
  constructor(obj) {
    if (obj.by_zip_codes) {
      this.zip_code = obj.by_zip_codes.zip_code;
      this.median_rent = obj.by_zip_codes.median_rent;
      this.median_household_income = obj.by_zip_codes.median_household_income;
      this.mean_household_income = obj.by_zip_codes.mean_household_income;
    }
  }
}
